import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "emailError"]
  static values = { checkUrl: String }

  emailTargetConnected(field) {
    this._debouncedCheck = debounce(() => this.#checkEmail(), 300)
    field.addEventListener("input", this._debouncedCheck)
  }

  emailTargetDisconnected(field) {
    field.removeEventListener("input", this._debouncedCheck)
  }

  async #checkEmail() {
    const email = this.emailTarget.value.trim()

    if (!email) {
      this.#clearEmailError()
      return
    }

    const url = `${this.checkUrlValue}?email=${encodeURIComponent(email)}`
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const data = await response.json()

    if (data.managed) {
      this.#showEmailError(data.edit_url)
    } else {
      this.#clearEmailError()
    }
  }

  #clearEmailError() {
    this.emailErrorTarget.hidden = true
    this.emailErrorTarget.replaceChildren()
  }

  #showEmailError(editUrl) {
    const text = document.createTextNode("This user is already in the enterprise. ")
    const link = document.createElement("a")
    link.href = editUrl
    link.textContent = "Update their access here."
    link.className = "font-semibold underline"

    this.emailErrorTarget.replaceChildren(text, link)
    this.emailErrorTarget.hidden = false
  }
}

function debounce(fn, delay) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}
